import { render } from "./OrbitRiskList.vue?vue&type=template&id=ed038a1e"
import script from "./OrbitRiskList.vue?vue&type=script&lang=js"
export * from "./OrbitRiskList.vue?vue&type=script&lang=js"

import "./OrbitRiskList.vue?vue&type=style&index=0&id=ed038a1e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__